import actions from './alarm.actions';
import mutations from './alarm.mutations';
import {
  AlarmDetails,
  KeyLabel,
  MetricsDetail,
  NotificationChannels
} from './alarm';
import { Alarm } from './alarm';
import getters from './alarm.getters';
import {
  InitAlarmDetails,
  InitOptions,
  InitopOptions,
  InitNotificationChannels,
  AlarmCapabilities
} from './alarm-constant';

export interface State {
  alarmCapabilities: KeyLabel[];
  currentCapability: KeyLabel;
  alarmApplications: KeyLabel[];
  currentApplication: KeyLabel;
  refreshConfiguredAlerts: boolean;
  alarmService: Alarm[];
  configuredAlert: Array<any>;
  configuredTotal: number;
  total: number;
  alarmDetails: AlarmDetails;
  notificationChannels: NotificationChannels;
  options: any;
  opOptions: Array<any>;
  timezoneOptions: Array<any>;
  metricsConfig: MetricsDetail[];
  chosenIndex: number;
  serviceId: string;
  exists: boolean;
  existsNotification: boolean;
  timezone: string;
  username: string;
  showForm: boolean;
  showNotification: boolean;
  showAlerts: boolean;
  showTimeZone: boolean;
  showTimeZoneeditPage: boolean;
  headerTag: string;
  loading: boolean;
}

const initState: State = {
  alarmCapabilities: AlarmCapabilities,
  currentCapability: AlarmCapabilities[0],
  alarmApplications: [],
  currentApplication: { key: '', label: '' },
  refreshConfiguredAlerts: false,
  alarmService: [],
  configuredAlert: [],
  configuredTotal: 0,
  total: 0,
  alarmDetails: InitAlarmDetails,
  notificationChannels: InitNotificationChannels,
  options: InitOptions,
  opOptions: InitopOptions,
  timezoneOptions: [],
  metricsConfig: [],
  chosenIndex: -1,
  serviceId: '',
  exists: false,
  existsNotification: false,
  timezone: '',
  username: '',
  showForm: false,
  showNotification: false,
  showAlerts: true,
  showTimeZone: false,
  showTimeZoneeditPage: false,
  headerTag: 'Alerts',
  loading: false
};

export default {
  namespaced: true,
  state: initState,
  getters,
  actions: actions,
  mutations: mutations
};
